import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { COULEURS_CHANTIER, type CouleurChantier } from '@/constants/couleursChantier';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface CouleurSelectorProps {
  value: string | null;
  onChange: (couleurHex: string) => void;
  error?: boolean;
}

export function CouleurSelector({ value, onChange, error }: CouleurSelectorProps) {
  return (
    <div className="space-y-2">
      <div
        className={cn(
          "grid grid-cols-5 gap-1.5 p-2 rounded-lg border w-fit",
          error ? "border-red-500 bg-red-500/10" : "border-border bg-muted/30"
        )}
      >
        <TooltipProvider delayDuration={200}>
          {COULEURS_CHANTIER.map((couleur: CouleurChantier) => {
            const isSelected = value === couleur.hex;
            return (
              <Tooltip key={couleur.id}>
                <TooltipTrigger asChild>
                  <button
                    type="button"
                    onClick={() => onChange(couleur.hex)}
                    className={cn(
                      "w-6 h-6 rounded-full transition-all duration-200 flex items-center justify-center",
                      "hover:scale-110 hover:ring-2 hover:ring-white/50",
                      "focus:outline-none focus:ring-2 focus:ring-white/50",
                      isSelected && "ring-2 ring-white ring-offset-1 ring-offset-background scale-110"
                    )}
                    style={{ backgroundColor: couleur.hex }}
                    aria-label={`Sélectionner ${couleur.label}`}
                  >
                    {isSelected && (
                      <Check className="h-3 w-3 text-white drop-shadow-md" strokeWidth={3} />
                    )}
                  </button>
                </TooltipTrigger>
                <TooltipContent side="top" className="text-xs">
                  {couleur.label}
                </TooltipContent>
              </Tooltip>
            );
          })}
        </TooltipProvider>
      </div>
      {error && (
        <p className="text-sm text-red-500">Veuillez sélectionner une couleur</p>
      )}
    </div>
  );
}
